import React from "react";
import { Link } from "react-router-dom";

const BtnAppStore = () => {
  return (
    <Link to="#" className="">
      <img src="/assets/images/vecteurs/Logo app store.svg" alt="app store" 
      className="h-12"/>
    </Link>
  );
};

export default BtnAppStore;
